// Configuração de Status do Sistema
export const STATUS_LIST = [
  { value: 'pedido_criado', label: 'Pedido Criado', order: 1 },
  { value: 'pedido_cancelado', label: 'Pedido Cancelado', order: 2 },
  { value: 'coletado', label: 'Coletado', order: 3 },
  { value: 'recebido_deposito', label: 'Recebido no Depósito', order: 4 },
  { value: 'em_consolidacao', label: 'Em Consolidação', order: 5 },
  { value: 'em_transito', label: 'Em Trânsito', order: 6 },
  { value: 'chegou_ao_destino', label: 'Chegou ao Destino', order: 7 },
  { value: 'disponivel_retirada', label: 'Disponível para Retirada', order: 8 },
  { value: 'retira_inspecao', label: 'Retira para Inspeção', order: 9 },
  { value: 'aguardando_documentacao_complementar', label: 'Aguardando Documentação Complementar', order: 10 },
  { value: 'taxacao_aplicada', label: 'Taxação Aplicada', order: 11 },
  { value: 'destinatario_ausente', label: 'Destinatário Ausente', order: 12 },
  { value: 'carga_avariada', label: 'Carga Avariada', order: 13 },
  { value: 'extraviado', label: 'Extraviado', order: 14 },
  { value: 'devolucao_remetente', label: 'Devolução ao Remetente', order: 15 },
  { value: 'entrega_cancelada', label: 'Entrega Cancelada', order: 16 },
  { value: 'entrega_confirmada', label: 'Entrega Confirmada', order: 17 }
];

// Status que não podem voltar (progressão linear)
export const LINEAR_STATUSES = [
  'pedido_cancelado',
  'coletado',
  'recebido_deposito',
  'em_consolidacao',
  'em_transito',
  'chegou_ao_destino',
  'disponivel_retirada',
  'retira_inspecao',
  'aguardando_documentacao_complementar',
  'taxacao_aplicada',
  'destinatario_ausente',
  'carga_avariada',
  'extraviado',
  'devolucao_remetente',
  'entrega_cancelada',
  'entrega_confirmada'
];

// Status que podem ser definidos apenas por Administrador/Gerente
export const ADMIN_ONLY_STATUSES = [
  'pedido_criado',
  'pedido_cancelado',
  'coletado',
  'recebido_deposito',
  'em_consolidacao',
  'em_transito',
  'chegou_ao_destino',
  'disponivel_retirada',
  'retira_inspecao',
  'aguardando_documentacao_complementar',
  'taxacao_aplicada',
  'destinatario_ausente',
  'carga_avariada',
  'extraviado',
  'devolucao_remetente',
  'entrega_cancelada',
  'entrega_confirmada'
];

// Status que podem ser alterados por Entregador/Transportadora (com código)
export const DELIVERY_STATUSES = [
  'destinatario_ausente',
  'carga_avariada',
  'extraviado',
  'devolucao_remetente',
  'entrega_cancelada',
  'entrega_confirmada'
];

// Status que podem ser alterados por Transportadora (com código)
export const TRANSPORT_STATUSES = [
  'destinatario_ausente',
  'carga_avariada',
  'extraviado',
  'devolucao_remetente',
  'entrega_cancelada',
  'entrega_confirmada'
];

// Função para obter informações do status
export const getStatusInfo = (status) => {
  const statusObj = STATUS_LIST.find(s => s.value === status);
  if (!statusObj) {
    return { value: status, label: status, order: 0 };
  }
  return statusObj;
};

// Função para validar transição de status
export const canChangeStatus = (currentStatus, newStatus, userRole = null, hasCode = false) => {
  // Se for o mesmo status, não pode mudar
  if (currentStatus === newStatus) {
    return { allowed: false, reason: 'Status já está definido' };
  }

  const currentInfo = getStatusInfo(currentStatus);
  const newInfo = getStatusInfo(newStatus);

  // Status cancelados/finais não podem ser alterados
  if (currentStatus === 'pedido_cancelado' ||
      currentStatus === 'entrega_confirmada' ||
      currentStatus === 'devolucao_remetente') {
    return { allowed: false, reason: 'Status final não pode ser alterado' };
  }

  // Verificar se é status linear (não pode voltar)
  if (LINEAR_STATUSES.includes(currentStatus) && LINEAR_STATUSES.includes(newStatus)) {
    const currentOrder = currentInfo.order;
    const newOrder = newInfo.order;

    // Não pode voltar em status linear
    if (newOrder < currentOrder) {
      return { allowed: false, reason: 'Não é possível retroceder neste fluxo' };
    }

    // Não pode pular muitos status de uma vez (máximo 2)
    if (newOrder > currentOrder + 2) {
      return { allowed: false, reason: 'Não é possível pular etapas' };
    }
  }

  // Admin, Gerente e Funcionário podem atualizar qualquer status
  const canUpdateAnyStatus = userRole === 'admin' || userRole === 'gerente' || userRole === 'funcionario';

  // Verificar permissões de acesso
  if (ADMIN_ONLY_STATUSES.includes(newStatus)) {
    if (!canUpdateAnyStatus) {
      return { allowed: false, reason: 'Apenas administradores, gerentes ou funcionários podem definir este status' };
    }
  }

  // Verificar status de entrega (requer código para transportador/entregador)
  if (DELIVERY_STATUSES.includes(newStatus)) {
    if (!hasCode && !canUpdateAnyStatus) {
      return { allowed: false, reason: 'Código de atualização necessário para este status' };
    }
  }

  // Verificar status de transporte (requer código para transportador/entregador)
  if (TRANSPORT_STATUSES.includes(newStatus)) {
    if (!hasCode && !canUpdateAnyStatus) {
      return { allowed: false, reason: 'Código de atualização necessário para este status' };
    }
  }

  return { allowed: true };
};

// Função para obter próximos status possíveis
export const getNextPossibleStatuses = (currentStatus, userRole = null, hasCode = false) => {
  return STATUS_LIST.filter(status => {
    const validation = canChangeStatus(currentStatus, status.value, userRole, hasCode);
    return validation.allowed;
  }).map(status => ({
    value: status.value,
    label: status.label
  }));
};

// Função para obter ícone do status
export const getStatusIcon = (status) => {
  const iconMap = {
    'pedido_criado': 'HiClock',
    'pedido_cancelado': 'HiXCircle',
    'coletado': 'HiTruck',
    'recebido_deposito': 'HiLocationMarker',
    'em_consolidacao': 'HiCube',
    'em_transito': 'HiTruck',
    'chegou_ao_destino': 'HiLocationMarker',
    'disponivel_retirada': 'HiLocationMarker',
    'embalado': 'HiArchive',
    'em_documentacao': 'HiDocumentText',
    'aguardando_despacho_aduaneiro': 'HiClock',
    'liberado_aduana_origem': 'HiCheckCircle',
    'aguardando_embarque': 'HiClock',
    'embarcado': 'HiTruck',
    'em_transito_internacional': 'HiTruck',
    'chegada_destino': 'HiLocationMarker',
    'em_despacho_aduaneiro': 'HiDocumentText',
    'aguardando_liberacao_aduaneira': 'HiClock',
    'retira_inspecao': 'HiShieldCheck',
    'aguardando_documentacao_complementar': 'HiClock',
    'taxacao_aplicada': 'HiCash',
    'liberado_aduana_destino': 'HiCheckCircle',
    'em_transporte_local': 'HiTruck',
    'endereco_incorreto': 'HiXCircle',
    'destinatario_ausente': 'HiUser',
    'carga_avariada': 'HiExclamationCircle',
    'extraviado': 'HiExclamationCircle',
    'devolucao_remetente': 'HiArrowLeft',
    'entrega_cancelada': 'HiXCircle',
    'entrega_confirmada': 'HiCheckCircle'
  };

  return iconMap[status] || 'HiClock';
};

// Função para obter cor do status
export const getStatusColor = (status) => {
  const colorMap = {
    'pedido_criado': '#f59e0b',
    'pedido_cancelado': '#ef4444',
    'coletado': '#3b82f6',
    'recebido_deposito': '#3b82f6',
    'em_consolidacao': '#8b5cf6',
    'em_transito': '#3b82f6',
    'chegou_ao_destino': '#10b981',
    'disponivel_retirada': '#10b981',
    'embalado': '#8b5cf6',
    'em_documentacao': '#6366f1',
    'aguardando_despacho_aduaneiro': '#f59e0b',
    'liberado_aduana_origem': '#10b981',
    'aguardando_embarque': '#f59e0b',
    'embarcado': '#3b82f6',
    'em_transito_internacional': '#3b82f6',
    'chegada_destino': '#10b981',
    'em_despacho_aduaneiro': '#6366f1',
    'aguardando_liberacao_aduaneira': '#f59e0b',
    'retira_inspecao': '#f59e0b',
    'aguardando_documentacao_complementar': '#f59e0b',
    'taxacao_aplicada': '#f59e0b',
    'liberado_aduana_destino': '#10b981',
    'em_transporte_local': '#3b82f6',
    'endereco_incorreto': '#ef4444',
    'destinatario_ausente': '#f59e0b',
    'carga_avariada': '#ef4444',
    'extraviado': '#ef4444',
    'devolucao_remetente': '#ef4444',
    'entrega_cancelada': '#ef4444',
    'entrega_confirmada': '#10b981'
  };

  return colorMap[status] || '#6b7280';
};

